import { StyleSheet } from '@react-pdf/renderer'

// Healing PDF Document globalStyles
export const globalStyles = StyleSheet.create({
	page: {
		padding: 30,
		color: '#4F6184',
		paddingBottom: 135,
		fontFamily: 'sofiaProMed',
		height: '100%',
		width: '100%',
	},
	pageHeaderContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		fontSize: 8,
		color: '#4F6184',
		padding: 3,
		borderBottomWidth: 1,
		borderBottomColor: '#4F6184',
	},
	pageFooterContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		paddingTop: 3,
		borderTopWidth: 1,
		borderTopColor: '#E7ECF2',
		marginBottom: 15,
	},
	disclaimerText: {
		fontSize: 6,
		color: '#4F6184',
		marginBottom: 10,
	},
	footerText: {
		fontSize: 8,
		color: '#4F6184',
	},
	reportHeader: {
		display: 'flex',
	},
	title: {
		fontSize: 20,
	},
	subtitle: {
		fontSize: 18,
		margin: 12,
	},
	text: {
		fontSize: 10,
		marginTop: 5,
		color: '#4F6184',
		fontFamily: 'sofiaProLight',
	},
	image: {
		width: 105,
		position: 'absolute',
		right: 0,
	},
	disclaimerImage: {
		width: 65,
	},
	header: {
		fontSize: 12,
		marginBottom: 20,
		textAlign: 'center',
		color: 'grey',
	},
	pageNumber: {
		position: 'absolute',
		fontSize: 8,
		bottom: 30,
		right: 30,
		left: 30,
		textAlign: 'right',
		color: 'grey',
	},
	smHeader: {
		fontSize: 8,
		color: '#4F6184',
		fontFamily: 'sofiaProBold',
	},
	mdHeader: {
		fontSize: 10,
		color: '#4F6184',
	},
	lgHeader: {
		fontSize: 12,
		color: '#4F6184',
		fontFamily: 'sofiaProBold',
	},
	detailContainer: {
		paddingTop: 10,
		paddingBottom: 20,
	},
	variantDetailContainer: {
		marginTop: 10,
		marginBottom: 20,
		borderLeftColor: '#E7ECF2',
		borderLeftStyle: 'solid',
		borderLeftWidth: 1,
	},
	detailContentContainer: {
		borderLeftColor: '#E7ECF2',
		borderLeftStyle: 'solid',
		borderLeftWidth: 1,
	},
	detailContent: {
		padding: 3,
		paddingBottom: 7,
	},
	detailSection: {
		paddingTop: 7,
		paddingBottom: 7,
		paddingRight: 10,
		paddingLeft: 10,
		borderRightColor: '#E7ECF2',
		borderRightStyle: 'solid',
		borderRightWidth: 1,
		borderBottomColor: '#E7ECF2',
		borderBottomStyle: 'solid',
		borderBottomWidth: 1,
	},
	detailSectionHeaderBar: {
		padding: 7,
		backgroundColor: '#E7ECF2',
	},
	quarterWidth: {
		width: '25%',
	},
	thirdWidth: {
		width: '33.33%',
	},
	halfWidth: {
		width: '50%',
	},
	threeQuarterWidth: {
		width: '75%',
	},
	fullWidth: {
		width: '100%',
	},
	pageHeaderNumber: {
		textAlign: 'right',
		fontSize: 8,
	},
	invisible: {
		color: '#fff',
	},
	note: {
		fontSize: 11,
		color: '#4F6184',
		fontFamily: 'sofiaProLight',
	},
	summary: {
		paddingTop: 10,
		paddingBottom: 20,
		borderTopWidth: 1,
		borderTopColor: '#E7ECF2',
		marginTop: 20,
		marginBottom: 50,
	},
	italic: {
		fontFamily: 'sofiaProMedItalic',
	},
	light: {
		fontFamily: 'sofiaProLight',
	},
	med: {
		fontFamily: 'sofiaProMed',
	},
	bold: {
		fontFamily: 'sofiaProBold',
	},
	section: {
		marginBottom: 10,
		borderStyle: 'solid',
		borderWidth: '1px',
		borderColor: '#4F6184',
		borderRadius: '4px',
	},
	result: {
		display: 'flex',
		flexDirection: 'column',
	},
})
